export default __webpack_public_path__ + "static/octosign-859be6a80f0b6b5a0d2e89f15c44695c.png";